// For the duration of sendBatches.
var SEND_BATCHES_EVENT = 'HttpManager:_sendBatches';
// For the number of events successfully sent
var SEND_BATCHES_NOTIFICATION_EVENT = 'HttpManager:_sendBatchesNotification';
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payload, isAsync) {
        this.start = Date.now();
        this.name = name;
        this.isAsync = isAsync === true ? true : false;
        this.payload = payload;
    }
    /**
     * Identifies whether this event is a child event of a parent
     */
    PerfEvent.prototype.isChildEvt = function () {
        return false;
    };
    PerfEvent.prototype.complete = function () {
        this.time = Date.now() - this.start;
        this.exTime = this.time;
    };
    return PerfEvent;
}());
export { PerfEvent };
var PerfManager = /** @class */ (function () {
    function PerfManager(callbacks) {
        this._callbacks = callbacks;
    }
    PerfManager.prototype.create = function (src, payload, isAsync) {
        if (src === SEND_BATCHES_EVENT || src === SEND_BATCHES_NOTIFICATION_EVENT) {
            var evt = new PerfEvent(src, payload, isAsync);
            return evt;
        }
        return null;
    };
    PerfManager.prototype.fire = function (perfEvent) {
        if (perfEvent) {
            perfEvent.complete();
        }
        if (this._callbacks) {
            switch (perfEvent.name) {
                case SEND_BATCHES_EVENT:
                    this.handleSendBatches(perfEvent);
                    break;
                case SEND_BATCHES_NOTIFICATION_EVENT:
                    this.handleSendBatchesNotification(perfEvent);
                    break;
            }
        }
    };
    PerfManager.prototype.setCtx = function (_key, _value) { };
    PerfManager.prototype.getCtx = function (_key) { };
    PerfManager.prototype.handleSendBatches = function (perfEvent) {
        if (this._callbacks.requestProcessingStats) {
            // We just want to know how long SEND_BATCHES took.
            // It might not send all the events in its batch - see the notification for the actual number.
            // Also, there is currently a bug in its payload() callback where it doesn't
            // actually return the payload. https://msazure.visualstudio.com/One/_workitems/edit/7984398
            this._callbacks.requestProcessingStats(perfEvent.time || 0, 0);
        }
    };
    PerfManager.prototype.handleSendBatchesNotification = function (perfEvent) {
        if (this._callbacks.requestProcessingStats && perfEvent.payload) {
            var payload = perfEvent.payload();
            if (payload.batches &&
                payload.reason &&
                // SEND_BATCHES_NOTIFICATION_EVENT fires on both Sending and Success; we just want the Sending event
                payload.reason >= 1000 /* SendingUndefined */ &&
                payload.reason <= 1999 /* SendingEventMax */) {
                var numBatches = 0;
                for (var index in payload.batches) {
                    numBatches += payload.batches[index].evts.length;
                }
                // We don't care how long it's taken so far; the SEND_BATCHES contains the relevant timing info
                this._callbacks.requestProcessingStats(0, numBatches);
            }
        }
    };
    return PerfManager;
}());
export { PerfManager };
//# sourceMappingURL=PerfManager.js.map